import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { DossierTOC, type TocEntry } from "@/components/DossierTOC/DossierTOC";
import { CaseRail } from "@/components/CaseRail/CaseRail";
import { DemoRoute, tocForSlug } from "@/routes/DemoRoute";
import { PORTFOLIO_SLUGS } from "@/content";

function IndexRedirect() {
  const first = PORTFOLIO_SLUGS[0];
  return <Navigate to={`/dossiers/${first}`} replace />;
}

function DemoByParam() {
  const { slug } = useParams<{ slug: string }>();
  return <DemoRoute slug={slug!} />;
}

function TOCForParam() {
  const { slug } = useParams<{ slug: string }>();
  const entries: TocEntry[] = tocForSlug(slug);
  return <DossierTOC entries={entries} />;
}

export default function App() {
  return (
    <div className="shell">
      <Routes>
        <Route
          path="/dossiers/:slug"
          element={
            <>
              <TOCForParam />
              <DemoByParam />
              <CaseRail />
            </>
          }
        />
        <Route path="/" element={<IndexRedirect />} />
        <Route path="*" element={<IndexRedirect />} />
      </Routes>
    </div>
  );
}
